import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 13v-8l-3 3m6 0l-3 -3","key":"svg-0"}],["path",{"d":"M9 17l1 0","key":"svg-1"}],["path",{"d":"M14 17l1 0","key":"svg-2"}],["path",{"d":"M19 17l1 0","key":"svg-3"}],["path",{"d":"M4 17l1 0","key":"svg-4"}]]

const IconFoldUp = createReactComponent('outline', 'fold-up', 'FoldUp', __iconNode);

export default IconFoldUp;